export const weddingsMock = {
  brandSlug: '',
  brandCSS: '/etc.clientlibs/mcom-book-spa/brandingcontent.rzp.css',
  staticComponentClientLibsCSS: '/etc.clientlibs/mi-aem-trc/clientlibs/clientlib-site.min.css',
  currentPagePath: '/jcr:content',
  lastModifiedDate: 1678951738430,
  htmlPageItems: [],
  metaNames: [
    { name: 'keyword', value: '' },
    { name: 'msAppTileColor', value: '' },
    { name: 'msAppTileImage', value: '' },
    { name: 'onLoadLightboxURI', value: '' },
    { name: 'jcr:Description', value: '' },
    { name: 'showLightboxOnLoad', value: '' },
    { name: 'robots', value: '' },
  ],
  language: 'en',
  title: '',
  authorMode: false,
  ':items': {
    root: {
      ':items': {
        container: {
          ':items': {
            static_wrapper: {
              ':type': 'mi-aem-trc/components/content/static-wrapper/v1/static-wrapper',
              dataPagePath: '/content/marriott-trc/brand/language-masters/na/en/static-text-component-page',
              referencePath:
                '\n\n    \n    <div id="container-a15254b581" class="cmp-container">\n        \n\n\n<div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">\n    \n    <div class="header-text-cta top-no-spacing bottom-no-spacing aem-GridColumn aem-GridColumn--default--12">\n\n\t<div class="header-text container">\n\t\t<div class="row pb-5 mb-xl-5 mb-2">\n\t\t\t\n\t\t\t\n\t\t\t\n\t\t\t\t<div class="col-md-7 pt-md-2 pt-xl-0 pt-0 pb-xl-3 col-12">\n\t\t\t\t\t\n\t\t\t\t\t<div class="header-text__heading p-0 col-md-12 mt-md-3 mt-2 col-12 t-display-s">REQUEST FOR PROPOSAL</div>\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t\t<div class="col-md-5 pt-xl-2 mt-xl-1 pb-xl-3 col-12">\n\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t<div class="p-0 col-md-12 mt-md-0 mt-5 col-12 t-brand-font-alt-l"><p>Thank you for considering The Ritz-Carlton as the destination for your upcoming event. We look forward to creating an indelible memory of this meeting in the minds of your guests.Once you have completed all required fields for the brief Request for Proposal (RFP) form below, it will be our pleasure to contact you within one business day to discuss a proposal.</p>\n<p>Fields marked with an * are required.</p>\n</div>\n\t\t\t\t\t\t\n\n\t\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\n\t\t</div>\n\t</div>\n\n\n    \n</div>\n\n    \n</div>\n\n    </div>\n\n    \n',
            },
            rfp_meetings: {
              ':type': 'mi-aem-trc/components/content/rfp/v1/rfp-meetings',
              rfpjson: {
                key: {
                  instance: {
                    dataCustomClickTrackValue: 'RFP Meetings|Submit|internal',
                    formSubmit: {
                      submitButton: 'Submit',
                      clearButton: 'Clear',
                    },
                    contactInformation: {
                      name: 'Contact Information',
                      fieldSet: [
                        {
                          fieldName: 'Title',
                          inputOptions: null,
                          name: 'title',
                          errorMessage: 'Enter valid Title',
                          placeholder: null,
                          dependent: false,
                          mandatory: false,
                        },
                        {
                          fieldName: 'First Name',
                          inputOptions: null,
                          name: 'firstName',
                          errorMessage: 'First Name is required',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Last Name',
                          inputOptions: null,
                          name: 'lastName',
                          errorMessage: 'Last Name is required',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Address Line 1',
                          inputOptions: null,
                          name: 'addressLineOne',
                          errorMessage: 'Address Line 1 is required',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Address Line 2',
                          inputOptions: null,
                          name: 'addressLineTwo',
                          errorMessage: 'Enter Valid Address',
                          placeholder: null,
                          dependent: false,
                          mandatory: false,
                        },
                        {
                          fieldName: 'City',
                          inputOptions: null,
                          name: 'city',
                          errorMessage: 'City is required',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'State/Province',
                          inputOptions: null,
                          name: 'state',
                          errorMessage: 'State/Province is required',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Country/Region',
                          inputOptions: [
                            {
                              name: 'Afghanistan',
                              value: 'Afghanistan',
                            },
                            {
                              name: 'Aland Islands',
                              value: 'Aland Islands',
                            },
                            {
                              name: 'Albania',
                              value: 'Albania',
                            },
                            {
                              name: 'Algeria',
                              value: 'Algeria',
                            },
                            {
                              name: 'American Samoa',
                              value: 'American Samoa',
                            },
                            {
                              name: 'Andorra',
                              value: 'Andorra',
                            },
                            {
                              name: 'Angola',
                              value: 'Angola',
                            },
                            {
                              name: 'Anguilla',
                              value: 'Anguilla',
                            },
                            {
                              name: 'Antarctica',
                              value: 'Antarctica',
                            },
                            {
                              name: 'Antigua and Barbuda',
                              value: 'Antigua and Barbuda',
                            },
                            {
                              name: 'Argentina',
                              value: 'Argentina',
                            },
                            {
                              name: 'Armenia',
                              value: 'Armenia',
                            },
                            {
                              name: 'Aruba',
                              value: 'Aruba',
                            },
                            {
                              name: 'Australia',
                              value: 'Australia',
                            },
                            {
                              name: 'Austria',
                              value: 'Austria',
                            },
                            {
                              name: 'Azerbaijan',
                              value: 'Azerbaijan',
                            },
                            {
                              name: 'Bahamas',
                              value: 'Bahamas',
                            },
                            {
                              name: 'Bahrain',
                              value: 'Bahrain',
                            },
                            {
                              name: 'Bangladesh',
                              value: 'Bangladesh',
                            },
                            {
                              name: 'Barbados',
                              value: 'Barbados',
                            },
                            {
                              name: 'Belarus',
                              value: 'Belarus',
                            },
                            {
                              name: 'Belgium',
                              value: 'Belgium',
                            },
                            {
                              name: 'Belize',
                              value: 'Belize',
                            },
                            {
                              name: 'Benin',
                              value: 'Benin',
                            },
                            {
                              name: 'Bermuda',
                              value: 'Bermuda',
                            },
                            {
                              name: 'Bhutan',
                              value: 'Bhutan',
                            },
                            {
                              name: 'Bolivia',
                              value: 'Bolivia',
                            },
                            {
                              name: 'Bosnia and Herzegovina',
                              value: 'Bosnia and Herzegovina',
                            },
                            {
                              name: 'Botswana',
                              value: 'Botswana',
                            },
                            {
                              name: 'Bouvet Island',
                              value: 'Bouvet Island',
                            },
                            {
                              name: 'Brazil',
                              value: 'Brazil',
                            },
                            {
                              name: 'British Indian Ocean Territory',
                              value: 'British Indian Ocean Territory',
                            },
                            {
                              name: 'Brunei Darussalam',
                              value: 'Brunei Darussalam',
                            },
                            {
                              name: 'Bulgaria',
                              value: 'Bulgaria',
                            },
                            {
                              name: 'Burkina Faso',
                              value: 'Burkina Faso',
                            },
                            {
                              name: 'Burundi',
                              value: 'Burundi',
                            },
                            {
                              name: 'Cambodia',
                              value: 'Cambodia',
                            },
                            {
                              name: 'Cameroon',
                              value: 'Cameroon',
                            },
                            {
                              name: 'Canada',
                              value: 'Canada',
                            },
                            {
                              name: 'Cape Verde',
                              value: 'Cape Verde',
                            },
                            {
                              name: 'Caribbean Netherlands',
                              value: 'Caribbean Netherlands',
                            },
                            {
                              name: 'Cayman Islands',
                              value: 'Cayman Islands',
                            },
                            {
                              name: 'Central African Republic',
                              value: 'Central African Republic',
                            },
                            {
                              name: 'Chad',
                              value: 'Chad',
                            },
                            {
                              name: 'Chile',
                              value: 'Chile',
                            },
                            {
                              name: 'China',
                              value: 'China',
                            },
                            {
                              name: 'Christmas Island',
                              value: 'Christmas Island',
                            },
                            {
                              name: 'Cocos (Keeling) Islands',
                              value: 'Cocos (Keeling) Islands',
                            },
                            {
                              name: 'Colombia',
                              value: 'Colombia',
                            },
                            {
                              name: 'Comoros',
                              value: 'Comoros',
                            },
                            {
                              name: 'Congo',
                              value: 'Congo',
                            },
                            {
                              name: 'Congo - Democratic Republic of',
                              value: 'Congo - Democratic Republic of',
                            },
                            {
                              name: 'Cook Islands',
                              value: 'Cook Islands',
                            },
                            {
                              name: 'Costa Rica',
                              value: 'Costa Rica',
                            },
                            {
                              name: 'Croatia',
                              value: 'Croatia',
                            },
                            {
                              name: 'Cuba',
                              value: 'Cuba',
                            },
                            {
                              name: 'Curaçao',
                              value: 'Curaçao',
                            },
                            {
                              name: 'Cyprus',
                              value: 'Cyprus',
                            },
                            {
                              name: 'Czech Republic',
                              value: 'Czech Republic',
                            },
                            {
                              name: "Côte d'Ivoire",
                              value: "Côte d'Ivoire",
                            },
                            {
                              name: 'Denmark',
                              value: 'Denmark',
                            },
                            {
                              name: ' Djibouti',
                              value: ' Djibouti',
                            },
                            {
                              name: 'Dominica',
                              value: 'Dominica',
                            },
                            {
                              name: 'Dominican Republic',
                              value: 'Dominican Republic',
                            },
                            {
                              name: 'Ecuador',
                              value: 'Ecuador',
                            },
                            {
                              name: 'Egypt',
                              value: 'Egypt',
                            },
                            {
                              name: 'El Salvador',
                              value: 'El Salvador',
                            },
                            {
                              name: 'Equatorial Guinea',
                              value: 'Equatorial Guinea',
                            },
                            {
                              name: 'Eritrea',
                              value: 'Eritrea',
                            },
                            {
                              name: 'Estonia',
                              value: 'Estonia',
                            },
                            {
                              name: 'Ethiopia',
                              value: 'Ethiopia',
                            },
                            {
                              name: 'Falkland Islands',
                              value: 'Falkland Islands',
                            },
                            {
                              name: 'Faroe Islands',
                              value: 'Faroe Islands',
                            },
                            {
                              name: 'Fiji',
                              value: 'Fiji',
                            },
                            {
                              name: 'Finland',
                              value: 'Finland',
                            },
                            {
                              name: 'France',
                              value: 'France',
                            },
                            {
                              name: 'French Guiana',
                              value: 'French Guiana',
                            },
                            {
                              name: 'French Polynesia',
                              value: 'French Polynesia',
                            },
                            {
                              name: 'French Southern Territories',
                              value: 'French Southern Territories',
                            },
                            {
                              name: 'Gabon',
                              value: 'Gabon',
                            },
                            {
                              name: 'Gambia',
                              value: 'Gambia',
                            },
                            {
                              name: 'Georgia',
                              value: 'Georgia',
                            },
                            {
                              name: 'Germany',
                              value: 'Germany',
                            },
                            {
                              name: 'Ghana',
                              value: 'Ghana',
                            },
                            {
                              name: 'Gibraltar',
                              value: 'Gibraltar',
                            },
                            {
                              name: 'Greece',
                              value: 'Greece',
                            },
                            {
                              name: 'Greenland',
                              value: 'Greenland',
                            },
                            {
                              name: 'Grenada',
                              value: 'Grenada',
                            },
                            {
                              name: 'Guadeloupe',
                              value: 'Guadeloupe',
                            },
                            {
                              name: 'Guam',
                              value: 'Guam',
                            },
                            {
                              name: 'Guatemala',
                              value: 'Guatemala',
                            },
                            {
                              name: 'Guernsey',
                              value: 'Guernsey',
                            },
                            {
                              name: 'Guinea',
                              value: 'Guinea',
                            },
                            {
                              name: 'Guinea-Bissau',
                              value: 'Guinea-Bissau',
                            },
                            {
                              name: 'Guyana',
                              value: 'Guyana',
                            },
                            {
                              name: 'Haiti',
                              value: 'Haiti',
                            },
                            {
                              name: 'Heard and McDonald Islands',
                              value: 'Heard and McDonald Islands',
                            },
                            {
                              name: 'Honduras',
                              value: 'Honduras',
                            },
                            {
                              name: 'Hong Kong',
                              value: 'Hong Kong',
                            },
                            {
                              name: 'Hungary',
                              value: 'Hungary',
                            },
                            {
                              name: 'Iceland',
                              value: 'Iceland',
                            },
                            {
                              name: 'India',
                              value: 'India',
                            },
                            {
                              name: 'Indonesia',
                              value: 'Indonesia',
                            },
                            {
                              name: 'Iran',
                              value: 'Iran',
                            },
                            {
                              name: 'Iraq',
                              value: 'Iraq',
                            },
                            {
                              name: 'Ireland',
                              value: 'Ireland',
                            },
                            {
                              name: 'Isle of Man',
                              value: 'Isle of Man',
                            },
                            {
                              name: 'Israel',
                              value: 'Israel',
                            },
                            {
                              name: 'Italy',
                              value: 'Italy',
                            },
                            {
                              name: 'Jamaica',
                              value: 'Jamaica',
                            },
                            {
                              name: 'Japan',
                              value: 'Japan',
                            },
                            {
                              name: 'Jersey',
                              value: 'Jersey',
                            },
                            {
                              name: 'Jordan',
                              value: 'Jordan',
                            },
                            {
                              name: 'Kazakhstan',
                              value: 'Kazakhstan',
                            },
                            {
                              name: 'Kenya',
                              value: 'Kenya',
                            },
                            {
                              name: 'Kiribati',
                              value: 'Kiribati',
                            },
                            {
                              name: 'Kuwait',
                              value: 'Kuwait',
                            },
                            {
                              name: 'Kyrgyzstan',
                              value: 'Kyrgyzstan',
                            },
                            {
                              name: "Lao People's Democratic Republic",
                              value: "Lao People's Democratic Republic",
                            },
                            {
                              name: 'Latvia',
                              value: 'Latvia',
                            },
                            {
                              name: 'Lebanon',
                              value: 'Lebanon',
                            },
                            {
                              name: 'Lesotho',
                              value: 'Lesotho',
                            },
                            {
                              name: 'Liberia',
                              value: 'Liberia',
                            },
                            {
                              name: 'Libya',
                              value: 'Libya',
                            },
                            {
                              name: 'Liechtenstein',
                              value: 'Liechtenstein',
                            },
                            {
                              name: 'Lithuania',
                              value: 'Lithuania',
                            },
                            {
                              name: 'Luxembourg',
                              value: 'Luxembourg',
                            },
                            {
                              name: 'Macau',
                              value: 'Macau',
                            },
                            {
                              name: 'Macedonia',
                              value: 'Macedonia',
                            },
                            {
                              name: 'Madagascar',
                              value: 'Madagascar',
                            },
                            {
                              name: 'Malawi',
                              value: 'Malawi',
                            },
                            {
                              name: 'Malaysia',
                              value: 'Malaysia',
                            },
                            {
                              name: 'Maldives',
                              value: 'Maldives',
                            },
                            {
                              name: 'Mali',
                              value: 'Mali',
                            },
                            {
                              name: 'Malta',
                              value: 'Malta',
                            },
                            {
                              name: 'Marshall Islands',
                              value: 'Marshall Islands',
                            },
                            {
                              name: 'Martinique',
                              value: 'Martinique',
                            },
                            {
                              name: 'Mauritania',
                              value: 'Mauritania',
                            },
                            {
                              name: 'Mauritius',
                              value: 'Mauritius',
                            },
                            {
                              name: 'Mayotte',
                              value: 'Mayotte',
                            },
                            {
                              name: 'Mexico',
                              value: 'Mexico',
                            },
                            {
                              name: 'Micronesia - Federated States of',
                              value: 'Micronesia - Federated States of',
                            },
                            {
                              name: 'Moldova',
                              value: 'Moldova',
                            },
                            {
                              name: 'Monaco',
                              value: 'Monaco',
                            },
                            {
                              name: 'Mongolia',
                              value: 'Mongolia',
                            },
                            {
                              name: 'Montenegro',
                              value: 'Montenegro',
                            },
                            {
                              name: 'Montserrat',
                              value: 'Montserrat',
                            },
                            {
                              name: 'Morocco',
                              value: 'Morocco',
                            },
                            {
                              name: 'Mozambique',
                              value: 'Mozambique',
                            },
                            {
                              name: 'Myanmar',
                              value: 'Myanmar',
                            },
                            {
                              name: 'Namibia',
                              value: 'Namibia',
                            },
                            {
                              name: 'Nauru',
                              value: 'Nauru',
                            },
                            {
                              name: 'Nepal',
                              value: 'Nepal',
                            },
                            {
                              name: 'New Caledonia',
                              value: 'New Caledonia',
                            },
                            {
                              name: 'New Zealand',
                              value: 'New Zealand',
                            },
                            {
                              name: 'Nicaragua',
                              value: 'Nicaragua',
                            },
                            {
                              name: 'Niger',
                              value: 'Niger',
                            },
                            {
                              name: 'Nigeria',
                              value: 'Nigeria',
                            },
                            {
                              name: 'Niue',
                              value: 'Niue',
                            },
                            {
                              name: 'Norfolk Island',
                              value: 'Norfolk Island',
                            },
                            {
                              name: 'North Korea',
                              value: 'North Korea',
                            },
                            {
                              name: 'Northern Mariana Islands',
                              value: 'Northern Mariana Islands',
                            },
                            {
                              name: 'Norway',
                              value: 'Norway',
                            },
                            {
                              name: 'Oman',
                              value: 'Oman',
                            },
                            {
                              name: 'Pakistan',
                              value: 'Pakistan',
                            },
                            {
                              name: 'Palau',
                              value: 'Palau',
                            },
                            {
                              name: 'Palestine - State of',
                              value: 'Palestine - State of',
                            },
                            {
                              name: 'Panama',
                              value: 'Panama',
                            },
                            {
                              name: 'Papua New Guinea',
                              value: 'Papua New Guinea',
                            },
                            {
                              name: 'Paraguay',
                              value: 'Paraguay',
                            },
                            {
                              name: 'Peru',
                              value: 'Peru',
                            },
                            {
                              name: 'Philippines',
                              value: 'Philippines',
                            },
                            {
                              name: 'Pitcairn',
                              value: 'Pitcairn',
                            },
                            {
                              name: 'Poland',
                              value: 'Poland',
                            },
                            {
                              name: 'Portugal',
                              value: 'Portugal',
                            },
                            {
                              name: 'Puerto Rico',
                              value: 'Puerto Rico',
                            },
                            {
                              name: 'Qatar',
                              value: 'Qatar',
                            },
                            {
                              name: 'Romania',
                              value: 'Romania',
                            },
                            {
                              name: 'Russian Federation',
                              value: 'Russian Federation',
                            },
                            {
                              name: 'Rwanda',
                              value: 'Rwanda',
                            },
                            {
                              name: 'Réunion',
                              value: 'Réunion',
                            },
                            {
                              name: 'Saint Barthélemy',
                              value: 'Saint Barthélemy',
                            },
                            {
                              name: 'Saint Helena',
                              value: 'Saint Helena',
                            },
                            {
                              name: 'Saint Kitts and Nevis',
                              value: 'Saint Kitts and Nevis',
                            },
                            {
                              name: 'Saint Lucia',
                              value: 'Saint Lucia',
                            },
                            {
                              name: 'Saint Vincent and the Grenadines',
                              value: 'Saint Vincent and the Grenadines',
                            },
                            {
                              name: 'Saint-Martin (France)',
                              value: 'Saint-Martin (France)',
                            },
                            {
                              name: 'Samoa',
                              value: 'Samoa',
                            },
                            {
                              name: 'San Marino',
                              value: 'San Marino',
                            },
                            {
                              name: 'Sao Tome and Principe',
                              value: 'Sao Tome and Principe',
                            },
                            {
                              name: 'Saudi Arabia',
                              value: 'Saudi Arabia',
                            },
                            {
                              name: 'Senegal',
                              value: 'Senegal',
                            },
                            {
                              name: 'Serbia',
                              value: 'Serbia',
                            },
                            {
                              name: 'Seychelles',
                              value: 'Seychelles',
                            },
                            {
                              name: 'Sierra Leone',
                              value: 'Sierra Leone',
                            },
                            {
                              name: 'Singapore',
                              value: 'Singapore',
                            },
                            {
                              name: 'Sint Maarten (Dutch part)',
                              value: 'Sint Maarten (Dutch part)',
                            },
                            {
                              name: 'Slovakia',
                              value: 'Slovakia',
                            },
                            {
                              name: 'Slovenia',
                              value: 'Slovenia',
                            },
                            {
                              name: 'Solomon Islands',
                              value: 'Solomon Islands',
                            },
                            {
                              name: 'Somalia',
                              value: 'Somalia',
                            },
                            {
                              name: 'South Africa',
                              value: 'South Africa',
                            },
                            {
                              name: 'South Georgia and the South Sandwich Islands',
                              value: 'South Georgia and the South Sandwich Islands',
                            },
                            {
                              name: 'South Korea',
                              value: 'South Korea',
                            },
                            {
                              name: 'South Sudan',
                              value: 'South Sudan',
                            },
                            {
                              name: 'Spain',
                              value: 'Spain',
                            },
                            {
                              name: 'Sri Lanka',
                              value: 'Sri Lanka',
                            },
                            {
                              name: 'St. Pierre and Miquelon',
                              value: 'St. Pierre and Miquelon',
                            },
                            {
                              name: 'Sudan',
                              value: 'Sudan',
                            },
                            {
                              name: 'Suriname',
                              value: 'Suriname',
                            },
                            {
                              name: 'Svalbard and Jan Mayen Islands',
                              value: 'Svalbard and Jan Mayen Islands',
                            },
                            {
                              name: 'Swaziland',
                              value: 'Swaziland',
                            },
                            {
                              name: 'Sweden',
                              value: 'Sweden',
                            },
                            {
                              name: 'Switzerland',
                              value: 'Switzerland',
                            },
                            {
                              name: 'Syria',
                              value: 'Syria',
                            },
                            {
                              name: 'Taiwan',
                              value: 'Taiwan',
                            },
                            {
                              name: 'Tajikistan',
                              value: 'Tajikistan',
                            },
                            {
                              name: 'Tanzania',
                              value: 'Tanzania',
                            },
                            {
                              name: 'Thailand',
                              value: 'Thailand',
                            },
                            {
                              name: 'The Netherlands',
                              value: 'The Netherlands',
                            },
                            {
                              name: 'Timor-Leste',
                              value: 'Timor-Leste',
                            },
                            {
                              name: 'Togo',
                              value: 'Togo',
                            },
                            {
                              name: 'Tokelau',
                              value: 'Tokelau',
                            },
                            {
                              name: 'Tonga',
                              value: 'Tonga',
                            },
                            {
                              name: 'Trinidad and Tobago',
                              value: 'Trinidad and Tobago',
                            },
                            {
                              name: 'Tunisia',
                              value: 'Tunisia',
                            },
                            {
                              name: 'Turkey',
                              value: 'Turkey',
                            },
                            {
                              name: 'Turkmenistan',
                              value: 'Turkmenistan',
                            },
                            {
                              name: 'Turks and Caicos Islands',
                              value: 'Turks and Caicos Islands',
                            },
                            {
                              name: 'Tuvalu',
                              value: 'Tuvalu',
                            },
                            {
                              name: 'Uganda',
                              value: 'Uganda',
                            },
                            {
                              name: 'Ukraine',
                              value: 'Ukraine',
                            },
                            {
                              name: 'United Arab Emirates',
                              value: 'United Arab Emirates',
                            },
                            {
                              name: 'United Kingdom',
                              value: 'United Kingdom',
                            },
                            {
                              name: 'United States',
                              value: 'United States',
                            },
                            {
                              name: 'United States Minor Outlying Islands',
                              value: 'United States Minor Outlying Islands',
                            },
                            {
                              name: 'Uruguay',
                              value: 'Uruguay',
                            },
                            {
                              name: 'Uzbekistan',
                              value: 'Uzbekistan',
                            },
                            {
                              name: 'Vanuatu',
                              value: 'Vanuatu',
                            },
                            {
                              name: 'Vatican',
                              value: 'Vatican',
                            },
                            {
                              name: 'Venezuela',
                              value: 'Venezuela',
                            },
                            {
                              name: 'Vietnam',
                              value: 'Vietnam',
                            },
                            {
                              name: 'Virgin Islands (British)',
                              value: 'Virgin Islands (British)',
                            },
                            {
                              name: 'Virgin Islands (U.S.)',
                              value: 'Virgin Islands (U.S.)',
                            },
                            {
                              name: 'Wallis and Futuna Islands',
                              value: 'Wallis and Futuna Islands',
                            },
                            {
                              name: 'Western Sahara',
                              value: 'Western Sahara',
                            },
                            {
                              name: 'Yemen',
                              value: 'Yemen',
                            },
                            {
                              name: 'Zambia',
                              value: 'Zambia',
                            },
                            {
                              name: 'Zimbabwe',
                              value: 'Zimbabwe',
                            },
                          ],
                          name: 'country',
                          errorMessage: 'Country/Region is required',
                          placeholder: 'Select Country/Region',
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Postal Code',
                          inputOptions: null,
                          name: 'postalCode',
                          errorMessage: 'Postal Code is required',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Phone Number',
                          inputOptions: null,
                          name: 'phoneNumber',
                          errorMessage: 'Phone Number is required. Please omit dashes (-).',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Email Address',
                          inputOptions: null,
                          name: 'emailAddress',
                          errorMessage: 'Enter a valid email address',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Company/Association',
                          inputOptions: null,
                          name: 'companyAssociation',
                          errorMessage: 'Company/Association is required',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                      ],
                    },
                    eventDetails: {
                      name: 'Event Details',
                      fieldSet: [
                        {
                          fieldName: 'Do you have a Request for Proposal prepared?',
                          inputOptions: [
                            {
                              dependency: ['rfpFile'],
                              option: 'Yes',
                            },
                            {
                              dependency: [
                                'formNoteOne',
                                'formNoteTwo',
                                'typeMeeting',
                                'keysSuccess',
                                'eventHistory',
                                'agenda',
                                'attendeeCountLargestSession',
                                'preferredSetupLargestSession',
                                'numBreakoutRooms',
                                'attendeeCountLargestSessionBreakout',
                                'vips',
                                'weddingRequirements',
                                'cateringRequirements',
                                'audioVisualRequirements',
                                'specialRequirements',
                                'additionalServices',
                                'questionsComments',
                                'additionalServicesOther',
                              ],
                              option: 'No',
                            },
                          ],
                          name: 'rfpPrepared',
                          errorMessage: null,
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Please upload your Request for Proposal',
                          inputOptions: null,
                          name: 'rfpFile',
                          errorMessage:
                            'In order to prepare a comprehensive proposal, we kindly ask you to provide some additional information. Please upload 1 file 1 MB in size in one of the following formats: .doc, .docx, or .pdf',
                          placeholder: 'Browse',
                          dependent: true,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Request for Proposal is required',
                          inputOptions: null,
                          name: 'formNoteOne',
                          errorMessage: null,
                          placeholder: null,
                          dependent: true,
                          mandatory: true,
                        },
                        {
                          fieldName:
                            'Please complete the fields listed below. Not all fields are required though every detail you provide will be helpful as we work to create a personalized proposal.',
                          inputOptions: null,
                          name: 'formNoteTwo',
                          errorMessage: null,
                          placeholder: null,
                          dependent: true,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Type of Meeting',
                          inputOptions: [
                            {
                              dependency: null,
                              option: 'Annual Meeting',
                            },
                            {
                              dependency: null,
                              option: 'Sales Meeting',
                            },
                            {
                              dependency: null,
                              option: 'Board Meeting',
                            },
                            {
                              dependency: null,
                              option: 'Trade show Exhibits',
                            },
                            {
                              dependency: null,
                              option: 'Client Entertainment',
                            },
                            {
                              dependency: null,
                              option: 'Training/Seminar',
                            },
                            {
                              dependency: null,
                              option: 'Convention',
                            },
                            {
                              dependency: null,
                              option: 'User Group',
                            },
                            {
                              dependency: null,
                              option: 'General Business Meeting',
                            },
                            {
                              dependency: null,
                              option: 'Other',
                            },
                            {
                              dependency: null,
                              option: 'Incentive',
                            },
                          ],
                          name: 'typeMeeting',
                          errorMessage: 'Type of Meeting is required',
                          placeholder: null,
                          dependent: true,
                          mandatory: true,
                        },
                        {
                          fieldName: 'What are the keys to success for this event?',
                          inputOptions: null,
                          name: 'keysSuccess',
                          errorMessage: 'Please enter Keys to Success',
                          placeholder: null,
                          dependent: true,
                          mandatory: false,
                        },
                        {
                          fieldName: 'Event History (previous locations/venues)',
                          inputOptions: null,
                          name: 'eventHistory',
                          errorMessage: 'Please enter Event History',
                          placeholder: null,
                          dependent: true,
                          mandatory: false,
                        },
                        {
                          fieldName: "Please upload your event's agenda if available.",
                          inputOptions: null,
                          name: 'agenda',
                          errorMessage: 'Please upload a file in one of the following formats: .docx, or .pdf',
                          placeholder: 'Browse',
                          dependent: true,
                          mandatory: false,
                        },
                        {
                          fieldName: 'Attendee Count for Largest Session',
                          inputOptions: [
                            {
                              dependency: null,
                              option: '1-50',
                            },
                            {
                              dependency: null,
                              option: '51-100',
                            },
                            {
                              dependency: null,
                              option: '101-200',
                            },
                            {
                              dependency: null,
                              option: '201-300',
                            },
                            {
                              dependency: null,
                              option: '301+',
                            },
                          ],
                          name: 'attendeeCountLargestSession',
                          errorMessage: 'Attendee Count for Largest Session is required',
                          placeholder: 'Select',
                          dependent: true,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Preferred Set Up for Largest Session',
                          inputOptions: [
                            {
                              dependency: null,
                              option: 'Classroom',
                            },
                            {
                              dependency: null,
                              option: 'Conference',
                            },
                            {
                              dependency: null,
                              option: 'Crescent',
                            },
                            {
                              dependency: null,
                              option: 'Hollow Square',
                            },
                            {
                              dependency: null,
                              option: 'Rounds',
                            },
                            {
                              dependency: null,
                              option: 'Theater',
                            },
                            {
                              dependency: null,
                              option: 'U-Shape',
                            },
                            {
                              dependency: null,
                              option: 'Other/Unknown',
                            },
                          ],
                          name: 'preferredSetupLargestSession',
                          errorMessage: 'Preferred Set Up for Largest Session is required',
                          placeholder: 'Select',
                          dependent: true,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Number of Breakout Rooms',
                          inputOptions: null,
                          name: 'numBreakoutRooms',
                          errorMessage: 'Number of Breakout Rooms is required. If not needed, enter 0.',
                          placeholder: null,
                          dependent: true,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Attendee Count for Largest Breakout Session',
                          inputOptions: null,
                          name: 'attendeeCountLargestSessionBreakout',
                          errorMessage:
                            'Attendee Count for Largest Breakout Session is required. If not needed, enter 0.',
                          placeholder: null,
                          dependent: true,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Will there be VIPs in attendance?',
                          inputOptions: [
                            {
                              dependency: null,
                              option: 'Yes',
                            },
                            {
                              dependency: null,
                              option: 'No',
                            },
                          ],
                          name: 'vips',
                          errorMessage: 'Please Select',
                          placeholder: null,
                          dependent: true,
                          mandatory: false,
                        },
                        {
                          fieldName: 'Catering Requirements',
                          inputOptions: null,
                          name: 'cateringRequirements',
                          errorMessage: 'Optional',
                          placeholder: null,
                          dependent: true,
                          mandatory: false,
                        },
                        {
                          fieldName: 'Audio/Visual Requirements',
                          inputOptions: null,
                          name: 'audioVisualRequirements',
                          errorMessage: 'Optional',
                          placeholder: null,
                          dependent: true,
                          mandatory: false,
                        },
                        {
                          fieldName: 'Special Requirements',
                          inputOptions: null,
                          name: 'specialRequirements',
                          errorMessage: 'Optional',
                          placeholder: null,
                          dependent: true,
                          mandatory: false,
                        },
                        {
                          fieldName: 'Additional Services',
                          inputOptions: [
                            {
                              dependency: null,
                              option: 'Flowers',
                            },
                            {
                              dependency: null,
                              option: 'Honeymoon',
                            },
                            {
                              dependency: null,
                              option: 'Linens',
                            },
                            {
                              dependency: null,
                              option: 'Music',
                            },
                            {
                              dependency: null,
                              option: 'Photography',
                            },
                            {
                              dependency: null,
                              option: 'Transportation',
                            },
                            {
                              dependency: null,
                              option: 'Videography',
                            },
                            {
                              dependency: null,
                              option: 'Wedding Cake',
                            },
                            {
                              dependency: null,
                              option: 'Wedding Coordination',
                            },
                            {
                              dependency: null,
                              option: 'Other',
                            },
                          ],
                          name: 'additionalServices',
                          errorMessage: 'Please Select',
                          placeholder: null,
                          dependent: true,
                          mandatory: false,
                        },
                        {
                          fieldName: 'Questions and/or Comments',
                          inputOptions: null,
                          name: 'questionsComments',
                          errorMessage: 'Optional',
                          placeholder: null,
                          dependent: true,
                          mandatory: false,
                        },
                        {
                          fieldName: 'Please specify other',
                          inputOptions: null,
                          name: 'specifyOther',
                          errorMessage: 'Please provide details',
                          placeholder: null,
                          dependent: true,
                          mandatory: true,
                        },
                      ],
                    },
                    enableTracking: true,
                    errorMessage: {
                      errorTitle: 'Apologies',
                      errorDetailedMessage:
                        'We are not able to submit your request via email. Please contact the hotel directly. We apologize for the inconvenience.',
                      errorEyebrowText: 'Our',
                    },
                    eventInformation: {
                      name: 'Event Information',
                      fieldSet: [
                        {
                          fieldName: 'Event Name',
                          inputOptions: null,
                          name: 'eventName',
                          errorMessage: 'Event Name is required',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Event Purpose',
                          inputOptions: null,
                          name: 'eventPurpose',
                          errorMessage: 'Event Purpose is required',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Estimated Number of Attendees',
                          inputOptions: null,
                          name: 'eventAttendees',
                          errorMessage: 'Estimated Number of Attendees is required',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Do you need guest rooms?',
                          inputOptions: [
                            {
                              dependency: ['eventGuestRooms'],
                              option: 'Yes',
                            },
                            {
                              dependency: null,
                              option: 'No',
                            },
                          ],
                          name: 'roomCountOption',
                          errorMessage: 'Please select',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Estimated Number of Guest Rooms',
                          inputOptions: null,
                          name: 'eventGuestRooms',
                          errorMessage: 'Please enter Estimated Guest Room Count',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                      ],
                    },
                    successUrl:
                      'https://www.ritzcarlton.com/en/hotels-and-resorts/meetings-and-celebrations/rfp-thank-you-page/',
                    eventDates: {
                      weekdaysLong: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                      dateFormat: 'Mon DD, YYYY',
                      dateFormatRange: 'Mon DD, YYYY - Mon DD, YYYY',
                      name: 'Event Dates',
                      fieldSet: [
                        {
                          fieldName: 'Decision Date',
                          inputOptions: null,
                          name: 'decisionDates',
                          errorMessage: 'Please Select Decision Dates',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Preferred Dates',
                          inputOptions: null,
                          name: 'preferredDates',
                          errorMessage: 'Please Select Preferred Dates',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Are your dates flexible?',
                          inputOptions: [
                            {
                              dependency: ['alternateDateOne', 'alternateDateTwo'],
                              option: 'Yes',
                            },
                            {
                              dependency: null,
                              option: 'No',
                            },
                          ],
                          name: 'flexibleDates',
                          errorMessage: 'Please Select',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Alternate Date 1',
                          inputOptions: null,
                          name: 'alternateDateOne',
                          errorMessage: 'Please Select Alternate Date 1',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                        {
                          fieldName: 'Alternate Date 2',
                          inputOptions: null,
                          name: 'alternateDateTwo',
                          errorMessage: 'Please Select Alternate Date 2',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                      ],
                      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                      monthsLong: [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                      ],
                      weekdaysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                    },
                    propertiesOfInterest: {
                      regions: [
                        {
                          regionId: 'europe',
                          region: 'EUROPE',
                          yachts: false,
                          hotelsList: [
                            {
                              shortTitle: 'Barcelona',
                              hotelName: 'Hotel Arts Barcelona',
                              marshaCode: 'BCNRZ',
                            },
                            {
                              shortTitle: 'Berlin',
                              hotelName: 'The Ritz-Carlton, Berlin',
                              marshaCode: 'BERZT',
                            },
                            {
                              shortTitle: 'Vienna',
                              hotelName: 'The Ritz-Carlton, Vienna',
                              marshaCode: 'VIERZ',
                            },
                            {
                              shortTitle: 'London',
                              hotelName: 'The London EDITION',
                              marshaCode: 'LONEB',
                            },
                            {
                              shortTitle: 'Budapest',
                              hotelName: 'The Ritz-Carlton, Budapest',
                              marshaCode: 'BUDRZ',
                            },
                            {
                              shortTitle: 'Geneva',
                              hotelName: 'The Ritz-Carlton Hotel de la Paix, Geneva',
                              marshaCode: 'GVARZ',
                            },
                            {
                              shortTitle: 'Istanbul',
                              hotelName: 'The Ritz-Carlton, Istanbul',
                              marshaCode: 'ISTRZ',
                            },
                            {
                              shortTitle: 'Penha Longa',
                              hotelName: 'Penha Longa Resort',
                              marshaCode: 'LISRZ',
                            },
                            {
                              shortTitle: 'Wolfsburg',
                              hotelName: 'The Ritz-Carlton, Wolfsburg',
                              marshaCode: 'WFGRZ',
                            },
                            {
                              shortTitle: 'Almaty',
                              hotelName: 'The Ritz-Carlton, Almaty',
                              marshaCode: 'ALARZ',
                            },
                            {
                              shortTitle: 'Astana',
                              hotelName: 'The Ritz-Carlton, Astana',
                              marshaCode: 'TSERZ',
                            },
                            {
                              shortTitle: 'Tenerife, Abama',
                              hotelName: 'The Ritz-Carlton Tenerife, Abama',
                              marshaCode: 'TFSRZ',
                            },
                          ],
                        },
                        {
                          regionId: 'yachts',
                          region: 'YACHTS',
                          yachts: true,
                          hotelsList: [
                            {
                              shortTitle: 'The Ritz-Carlton Yachts Collection',
                              hotelName: 'The Ritz-Carlton Yachts Collection',
                              marshaCode: 'TRCYC',
                            },
                          ],
                        },
                      ],
                      name: 'Ritz-Carlton Properties of Interest',
                      fieldSet: [
                        {
                          name: 'hotelOne',
                          fieldName: 'Hotel1',
                          placeholder: null,
                          errorMessage: 'Hotel1 Error Message',
                          dependent: false,
                          inputOptions: null,
                          mandatory: true,
                        },
                        {
                          name: 'hotelTwo',
                          fieldName: 'Hotel2 ',
                          placeholder: null,
                          errorMessage: 'Hotel2   Error Message',
                          dependent: false,
                          inputOptions: null,
                          mandatory: false,
                        },
                        {
                          name: 'hotelThree',
                          fieldName: 'Hotel3',
                          placeholder: null,
                          errorMessage: 'Hotel3  Error Message',
                          dependent: false,
                          inputOptions: null,
                          mandatory: false,
                        },
                      ],
                    },
                    successMessage: {
                      willBeInTouchLabel: "We'll be in Touch",
                      thankYouLabel: 'Thank You',
                      closeLabel: 'Close',
                      message:
                        'Thank you for your interest in The Ritz-Carlton. Your Request for Proposal has been successfully submitted and our Ladies and Gentlemen will reach out to you within one business day to discuss your proposal.',
                    },
                    labels: {
                      yesLabel: 'Yes',
                      noLabel: 'No',
                      otherLabel: 'Other',
                    },
                    privateDining: {
                      name: 'Private Dining',
                      fieldSet: [
                        {
                          fieldName: 'Would you like to reserve a private dining experience to complement your event?',
                          inputOptions: [
                            {
                              dependency: null,
                              option: 'Yes',
                            },
                            {
                              dependency: null,
                              option: 'No',
                            },
                          ],
                          name: 'privateDining',
                          errorMessage: 'Please select',
                          placeholder: null,
                          dependent: false,
                          mandatory: true,
                        },
                      ],
                    },
                  },
                  instanceType: 'meetings',
                },
              },
              pocEmailJson: '/content/marriott-trc/brand/global/rfp-emails.model.json',
            },
          },
          allowedComponents: {
            components: [
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/1-up-collage',
                title: '1 Up Collage',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/2-up-recirculation',
                title: '2 Up Recirculation',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/3-up-card-breaker',
                title: '3 Up Card Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/3-up-recirculation',
                title: '3 Up Recirculation',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/article-hero-compact',
                title: 'Article Hero Compact',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/article-with-maps-references',
                title: 'Article Maps with References',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/basic-carousel',
                title: 'Basic Carousel',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/brand-footer',
                title: 'Brand Footer',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/brand-highlight-package',
                title: 'Brand Highlight Package',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/brand-statement-image',
                title: 'Brand Statement with Image',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/carousel-breaker',
                title: 'Carousel Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/contact-us',
                title: 'Contact Us',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/components/content/container',
                title: 'Container',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/editorial-highlight-3up',
                title: 'Editorial Highlight 3Up',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/editorial-highlight-package',
                title: 'Editorial Highlight Package',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/editorial-highlight-v1',
                title: 'Editorial Highlight V1',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/editorial-package-3up',
                title: 'Editorial Package 3 Up Basic',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/components/ootb/experiencefragment',
                title: 'Experience Fragment',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/featured-hotel-carousel',
                title: 'Featured Hotel Carousel',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/feed-module-with-filter',
                title: 'Feed Module With Filter',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/header-text-cta',
                title: 'Header with Text and CTA',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/homepage-hero',
                title: 'Homepage Hero',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/horizontal-accordion',
                title: 'Horizontal Accordion',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/horizontally-tabbed-list',
                title: 'Horizontally Tabbed List',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/hotel-carousel-with-bg',
                title: 'Featured Hotel Carousel w/ BG image',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/hotel-data-table',
                title: 'Hotel Data Table',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/hub-hero-basic',
                title: 'Hub Hero Basic',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/hub-hero-layered',
                title: 'Hub Hero Layered',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/image-breaker',
                title: 'Image and Collage Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/inline-card',
                title: 'Inline Card',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/inline-image',
                title: 'Inline Image',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/navigation',
                title: 'Navigation',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/quote-w-image',
                title: 'Quote With Image',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/recirculation-carousel',
                title: 'Recirculation Carousel',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/reference',
                title: 'Reference Component',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/reserve-accordion',
                title: 'Reserve Accordion',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/reserve-carousel-subnav',
                title: 'Reserve Carousel SubNavigation',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/reserve-contact-us',
                title: 'Reserve Contact Us',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/reserve-hero',
                title: 'Reserve Hero',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/reserve-hero-data-table',
                title: 'Reserve Hero Data Table',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/reserve-highlight-carousel',
                title: 'Reserve Highlight Carousel',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/reserve-site-nav',
                title: 'Reserve Site Nav',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/reserve-statement',
                title: 'Reserve Statement',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/rfp-meetings',
                title: 'RFP Meetings',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/rfp-weddings',
                title: 'RFP Weddings',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/site-navigation',
                title: 'Header',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/statement-breaker',
                title: 'New Brand Statement Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/static-wrapper',
                title: 'Static Wrapper',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/staticsearchform',
                title: 'Booking Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/tabbed-hotel-map',
                title: 'Tabbed Hotel Map',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/components/ootb/title',
                title: 'Title',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/video-1-up',
                title: 'Video-1-Up',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/container/mi-aem-trc/proxy/components/content/wysiwyg-text',
                title: 'WYSIWYG',
              },
            ],
            applicable: false,
          },
          ':type': 'mi-aem-trc/components/content/container',
          ':itemsOrder': ['rfp_weddings', 'static_wrapper'],
          gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
          columnClassNames: {
            static_wrapper: 'aem-GridColumn aem-GridColumn--default--12',
            rfp_weddings: 'aem-GridColumn aem-GridColumn--default--12',
          },
          columnCount: 12,
        },
        'footer-responsivegrid': {
          ':items': {
            reference: {
              footerConfigPagePath:
                '/content/marriott-trc/brand/na/en/data-pages/footer/jcr:content/root/container/brand_footer',
              ':type': 'mi-aem-trc/components/content/reference/v1/reference',
              footer: 'true',
              headerConfigPagePath:
                '/content/marriott-trc/brand/na/en/data-pages/header/jcr:content/root/container/site_navigation',
              header: 'false',
              referencePath:
                '\n\n    \n    <div id="container-b3e37bccd8" class="cmp-container">\n        \n\n\n<div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">\n    \n    <div class="brand-footer aem-GridColumn aem-GridColumn--default--12">\n    <div class="brand-footer color-scheme2">\n        <div class="container">\n            <div class="row pt-5">\n                <div class="col-12 t-rc-alt-color mb-xl-5 mb-4 mt-5 brand-footer__top-separator"></div>\n                <div class="col-md-8 col-xl-7 col-12">\n                    <ul class="brand-footer__list d-flex flex-wrap pl-0 mb-0">\n                        \n                            <li class="pr-3 pb-md-4 pb-3 t-font-m">\n                                \n                                    <a href="https://careers.marriott.com/the-ritz-carlton-careers/">Careers</a>\n                                \n                            </li>\n                        \n                            <li class="pr-3 pb-md-4 pb-3 t-font-m">\n                                \n                                    <a href="https://www.ritzcarltonclub.com/">The Ritz-Carlton Club</a>\n                                \n                            </li>\n                        \n                            <li class="pr-3 pb-md-4 pb-3 t-font-m">\n                                \n                                    <a href="https://www.ritzcarltonshops.com/">RC Shops</a>\n                                \n                            </li>\n                        \n                            <li class="pr-3 pb-md-4 pb-3 t-font-m">\n                                \n                                    <a href="https://ritzcarltonleadershipcenter.com/">Leadership Center</a>\n                                \n                            </li>\n                        \n                            <li class="pr-3 pb-md-4 pb-3 t-font-m">\n                                \n                                    <a href="https://www.marriott.com/loyalty/createAccount/createAccountPage1.mi">Marriott Bonvoy</a>\n                                \n                            </li>\n                        \n                            <li class="pr-3 pb-md-4 pb-3 t-font-m">\n                                \n                                    <a href="https://www.ritzcarlton.com/en/contact" target="_blank" rel="noopener noreferrer">Contact</a>\n                                \n                            </li>\n                        \n                            <li class="pr-3 pb-md-4 pb-3 t-font-m">\n                                \n                                    <a href="https://news.marriott.com/ritz-carlton-hotels-resorts/" target="_blank" rel="noopener noreferrer">Media Contact</a>\n                                \n                            </li>\n                        \n                    </ul>\n                </div>\n\n                <div class="col-md-3 offset-md-1 offset-xl-2 col-12 pt-5 mt-2 pt-md-0 mt-md-0 pb-5 mb-2 pb-md-0 mb-md-0">\n                    <ul class="brand-footer__list d-flex flex-wrap pl-0 mb-0">\n                        \n                            <li class="pr-md-3 pr-5 mr-2 mr-md-0 t-font-alt-m">\n                                \n                                    <a href="https://www.facebook.com/ritzcarlton">\n                                        <span class="icon-facebook social-icon"></span></a>\n                                \n                            </li>\n                        \n                            <li class="pr-md-3 pr-5 mr-2 mr-md-0 t-font-alt-m">\n                                \n                                    <a href="https://instagram.com/ritzcarlton/" target="_blank" rel="noopener noreferrer">\n                                        <span class="icon-instagram social-icon"></span></a>\n                                \n                            </li>\n                        \n                            <li class="pr-md-3 pr-5 mr-2 mr-md-0 t-font-alt-m">\n                                \n                                    <a href="https://twitter.com/ritzcarlton">\n                                        <span class="icon-twitter social-icon"></span></a>\n                                \n                            </li>\n                        \n                            <li class="pr-md-3 pr-5 mr-2 mr-md-0 t-font-alt-m">\n                                \n                                    <a href="https://www.youtube.com/user/ritzcarlton" target="_blank" rel="noopener noreferrer">\n                                        <span class="icon-messenger social-icon"></span></a>\n                                \n                            </li>\n                        \n                            <li class="pr-md-3 pr-5 mr-2 mr-md-0 t-font-alt-m">\n                                \n                                    <a href="https://www.youtube.com/user/ritzcarlton" target="_blank" rel="noopener noreferrer">\n                                        <span class="icon-youtube social-icon"></span></a>\n                                \n                            </li>\n                        \n                    </ul>\n                    \n                        <div class="brand-footer__dropdown pt-5 mt-md-4 mt-5 pb-4 pb-md-0">\n                            <div class="mb-md-4"><span class="icon-globe pr-2"></span>English</div>\n                        </div>\n                    \n                </div>\n            </div>\n            <div class="row pt-md-5 mt-md-3 d-flex pb-3 pb-md-5">\n                <div class="col-md-8 col-xl-7 col-12 order-1 order-md-0 pb-5 pb-md-0">\n                    <div class="col-12 p-0 pb-md-2 t-font-alt-m">\n                        <p>RITZ® is a Registered Service Mark of The Ritz Hotel, Limited, and is used by The Ritz-Carlton Hotel Company under License.</p>\n<p>© 2022 The Ritz-Carlton Hotel Company, L.L.C. All rights reserved.</p>\n\n                    </div>\n                </div>\n                <div class="col-md-3 offset-md-1 offset-xl-2 col-12 order-0 order-md-1 mb-md-5">\n                    <div class="col-12 mb-md-3 p-0">\n                        <ul class="brand-footer__list__info pl-0 pb-4 mb-0 pb-md-0">\n                            \n                                <li class="d-inline-flex d-md-flex pr-3 pr-md-0 pb-3 pb-md-2">\n                                    \n                                        <a href="https://www.ritzcarlton.com/en/site-map" class="t-font-alt-m">SiteMap</a>\n                                    \n                                </li>\n                            \n                                <li class="d-inline-flex d-md-flex pr-3 pr-md-0 pb-3 pb-md-2">\n                                    \n                                        <a href="https://www.marriott.com/about/terms-of-use.mi" class="t-font-alt-m">Terms of Use</a>\n                                    \n                                </li>\n                            \n                                <li class="d-inline-flex d-md-flex pr-3 pr-md-0 pb-3 pb-md-2">\n                                    \n                                        <a href="https://beian.miit.gov.cn/" class="t-font-alt-m" target="_blank" rel="noopener noreferrer">BEIAN CN Site</a>\n                                    \n                                </li>\n                            \n                                <li class="d-inline-flex d-md-flex pr-3 pr-md-0 pb-3 pb-md-0">\n                                    \n                                        <a href="https://www.marriott.com/about/your-privacy-rights.mi" class="t-font-alt-m" target="_blank" rel="noopener noreferrer">Do Not Sell Info</a>\n                                    \n                                </li>\n                            \n                        </ul>\n                        <div class="t-rc-alt-color d-none d-md-flex t brand-footer__list__info--separator ml-n3"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n\n    \n\n</div>\n\n    \n</div>\n\n    </div>\n\n    \n',
            },
          },
          allowedComponents: {
            components: [
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/1-up-collage',
                title: '1 Up Collage',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/2-up-recirculation',
                title: '2 Up Recirculation',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/3-up-card-breaker',
                title: '3 Up Card Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/3-up-recirculation',
                title: '3 Up Recirculation',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/article-hero-compact',
                title: 'Article Hero Compact',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/article-with-maps-references',
                title: 'Article Maps with References',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/basic-carousel',
                title: 'Basic Carousel',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/brand-footer',
                title: 'Brand Footer',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/brand-highlight-package',
                title: 'Brand Highlight Package',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/brand-statement-image',
                title: 'Brand Statement with Image',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/carousel-breaker',
                title: 'Carousel Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/contact-us',
                title: 'Contact Us',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/components/content/container',
                title: 'Container',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/editorial-highlight-3up',
                title: 'Editorial Highlight 3Up',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/editorial-highlight-package',
                title: 'Editorial Highlight Package',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/editorial-highlight-v1',
                title: 'Editorial Highlight V1',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/editorial-package-3up',
                title: 'Editorial Package 3 Up Basic',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/components/ootb/experiencefragment',
                title: 'Experience Fragment',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/featured-hotel-carousel',
                title: 'Featured Hotel Carousel',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/feed-module-with-filter',
                title: 'Feed Module With Filter',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/header-text-cta',
                title: 'Header with Text and CTA',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/homepage-hero',
                title: 'Homepage Hero',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/horizontal-accordion',
                title: 'Horizontal Accordion',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/horizontally-tabbed-list',
                title: 'Horizontally Tabbed List',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/hotel-carousel-with-bg',
                title: 'Featured Hotel Carousel w/ BG image',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/hotel-data-table',
                title: 'Hotel Data Table',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/hub-hero-basic',
                title: 'Hub Hero Basic',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/hub-hero-layered',
                title: 'Hub Hero Layered',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/image-breaker',
                title: 'Image and Collage Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/inline-card',
                title: 'Inline Card',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/inline-image',
                title: 'Inline Image',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/navigation',
                title: 'Navigation',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/quote-w-image',
                title: 'Quote With Image',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/recirculation-carousel',
                title: 'Recirculation Carousel',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/reference',
                title: 'Reference Component',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/reserve-accordion',
                title: 'Reserve Accordion',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/reserve-carousel-subnav',
                title: 'Reserve Carousel SubNavigation',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/reserve-contact-us',
                title: 'Reserve Contact Us',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/reserve-hero',
                title: 'Reserve Hero',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/reserve-hero-data-table',
                title: 'Reserve Hero Data Table',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/reserve-highlight-carousel',
                title: 'Reserve Highlight Carousel',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/reserve-site-nav',
                title: 'Reserve Site Nav',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/reserve-statement',
                title: 'Reserve Statement',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/rfp-meetings',
                title: 'RFP Meetings',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/rfp-weddings',
                title: 'RFP Weddings',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/site-navigation',
                title: 'Header',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/statement-breaker',
                title: 'New Brand Statement Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/static-wrapper',
                title: 'Static Wrapper',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/staticsearchform',
                title: 'Booking Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/tabbed-hotel-map',
                title: 'Tabbed Hotel Map',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/components/ootb/title',
                title: 'Title',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/video-1-up',
                title: 'Video-1-Up',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/footer-responsivegrid/mi-aem-trc/proxy/components/content/wysiwyg-text',
                title: 'WYSIWYG',
              },
            ],
            applicable: false,
          },
          ':type': 'mi-aem-trc/components/content/container',
          ':itemsOrder': ['reference'],
          gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
          columnClassNames: { reference: 'aem-GridColumn aem-GridColumn--default--12' },
          columnCount: 12,
        },
        'header-responsivegrid': {
          ':items': {
            reference: {
              footerConfigPagePath:
                '/content/marriott-trc/brand/na/en/data-pages/footer/jcr:content/root/container/brand_footer',
              ':type': 'mi-aem-trc/components/content/reference/v1/reference',
              footer: 'false',
              headerConfigPagePath:
                '/content/marriott-trc/brand/na/en/data-pages/header/jcr:content/root/container/site_navigation',
              header: 'true',
              referencePath:
                '\n\n    \n    <div id="container-cca1170eee" class="cmp-container">\n        \n\n\n<div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">\n    \n    <div class="site-navigation aem-GridColumn aem-GridColumn--default--12">\n    <div class="site-navigation-component">\n        <div class="site-navigation-component__header container py-2 px-0 d-none d-xl-block">\n            <div class="d-flex justify-content-between py-1 px-0">\n                <a>\n                    <div class="brand-logo-trc site-navigation-component__logo"></div>\n                </a>\n                <div class="d-flex align-items-center">\n                    \n                    \n                        <a class="ml-4 m-button-s m-button-secondary site-navigation-component__header__cta t-rc-text-transform-capitalize" href="/content/marriott-trc/brand/apec.html">Sign in or Join</a>\n                    \n                </div>\n            </div>\n        </div>\n        <div class="site-navigation-component__nav d-none d-xl-block">\n            <div class="site-navigation-component__navigation container d-flex px-0 justify-content-between">\n                <nav class="site-navigation-component__navigation__navbar">\n                    <ul class="site-navigation-component__navigation__navbar__container pl-0 mb-0 d-flex align-items-center">\n                        \n                            \n                            \n                        \n                            \n                                <li class="site-navigation-component__navigation__navbar__container__item d-flex py-2">\n                                    <a href="/content/marriott-trc/brand.html" class="site-navigation-component__navigation__navbar__container__item__link py-3">\n                                        <div class="t-overline-medium">Residences</div>\n                                    </a>\n                                </li>\n                            \n                            \n                        \n                            \n                                <li class="site-navigation-component__navigation__navbar__container__item d-flex py-2">\n                                    <a href="https://marriott-sites-dev.adobecqms.net/en/content00/" class="site-navigation-component__navigation__navbar__container__item__link py-3">\n                                        <div class="t-overline-medium">Yachts</div>\n                                    </a>\n                                </li>\n                            \n                            \n                        \n                            \n                            \n                        \n                    </ul>\n                </nav>\n                \n                    <a class="ml-4 m-button-s m-button-primary site-navigation-component__navigation__cta t-rc-text-transform-capitalize my-2" href="https://marriott-sites-dev.adobecqms.net/en/">Reserve  Now</a>\n                \n            </div>\n        </div>\n        <div class="site-navigation-component__mobile__header container d-flex justify-content-between align-items-center py-2 d-xl-none d-block">\n            <div class="d-flex align-items-center">\n                <span class="site-navigation-component__mobile__header__menu icon-menu mr-2">\n                </span>\n                <a>\n                    <div class="brand-logo-trc site-navigation-component__logo"></div>\n                </a>\n            </div>\n            <div class="d-flex align-items-center">\n                <span class="site-navigation-component__mobile__header__globe icon-website"></span>\n                \n                    <a href="/content/marriott-trc/brand/apec.html">\n                        <span class="site-navigation-component__mobile__header__user icon-nav---account ml-3 pl-1"></span>\n                    </a>\n                \n            </div>\n        </div>\n        <div class="site-navigation-component__mobile__nav d-xl-none d-none">\n            <ul class="site-navigation-component__mobile__navbar pl-0 mb-0">\n                \n                    <li class="site-navigation-component__mobile__navbar__item">\n                        \n                        \n                    </li>\n                \n                    <li class="site-navigation-component__mobile__navbar__item">\n                        \n                            <a href="/content/marriott-trc/brand.html" class="site-navigation-component__mobile__navbar__item__link d-flex align-items-center justify-content-between py-3 container">\n                                <div class="t-brand-font-l">Residences</div>\n                            </a>\n                        \n                        \n                    </li>\n                \n                    <li class="site-navigation-component__mobile__navbar__item">\n                        \n                            <a href="https://marriott-sites-dev.adobecqms.net/en/content00/" class="site-navigation-component__mobile__navbar__item__link d-flex align-items-center justify-content-between py-3 container">\n                                <div class="t-brand-font-l">Yachts</div>\n                            </a>\n                        \n                        \n                    </li>\n                \n                    <li class="site-navigation-component__mobile__navbar__item">\n                        \n                        \n                    </li>\n                \n            </ul>\n        </div>\n    </div>\n\n\n\n    \n\n</div>\n\n    \n</div>\n\n    </div>\n\n    \n',
            },
          },
          allowedComponents: {
            components: [
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/1-up-collage',
                title: '1 Up Collage',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/2-up-recirculation',
                title: '2 Up Recirculation',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/3-up-card-breaker',
                title: '3 Up Card Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/3-up-recirculation',
                title: '3 Up Recirculation',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/article-hero-compact',
                title: 'Article Hero Compact',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/article-with-maps-references',
                title: 'Article Maps with References',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/basic-carousel',
                title: 'Basic Carousel',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/brand-footer',
                title: 'Brand Footer',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/brand-highlight-package',
                title: 'Brand Highlight Package',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/brand-statement-image',
                title: 'Brand Statement with Image',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/carousel-breaker',
                title: 'Carousel Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/contact-us',
                title: 'Contact Us',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/components/content/container',
                title: 'Container',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/editorial-highlight-3up',
                title: 'Editorial Highlight 3Up',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/editorial-highlight-package',
                title: 'Editorial Highlight Package',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/editorial-highlight-v1',
                title: 'Editorial Highlight V1',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/editorial-package-3up',
                title: 'Editorial Package 3 Up Basic',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/components/ootb/experiencefragment',
                title: 'Experience Fragment',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/featured-hotel-carousel',
                title: 'Featured Hotel Carousel',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/feed-module-with-filter',
                title: 'Feed Module With Filter',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/header-text-cta',
                title: 'Header with Text and CTA',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/homepage-hero',
                title: 'Homepage Hero',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/horizontal-accordion',
                title: 'Horizontal Accordion',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/horizontally-tabbed-list',
                title: 'Horizontally Tabbed List',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/hotel-carousel-with-bg',
                title: 'Featured Hotel Carousel w/ BG image',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/hotel-data-table',
                title: 'Hotel Data Table',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/hub-hero-basic',
                title: 'Hub Hero Basic',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/hub-hero-layered',
                title: 'Hub Hero Layered',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/image-breaker',
                title: 'Image and Collage Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/inline-card',
                title: 'Inline Card',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/inline-image',
                title: 'Inline Image',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/navigation',
                title: 'Navigation',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/quote-w-image',
                title: 'Quote With Image',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/recirculation-carousel',
                title: 'Recirculation Carousel',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/reference',
                title: 'Reference Component',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/reserve-accordion',
                title: 'Reserve Accordion',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/reserve-carousel-subnav',
                title: 'Reserve Carousel SubNavigation',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/reserve-contact-us',
                title: 'Reserve Contact Us',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/reserve-hero',
                title: 'Reserve Hero',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/reserve-hero-data-table',
                title: 'Reserve Hero Data Table',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/reserve-highlight-carousel',
                title: 'Reserve Highlight Carousel',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/reserve-site-nav',
                title: 'Reserve Site Nav',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/reserve-statement',
                title: 'Reserve Statement',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/rfp-meetings',
                title: 'RFP Meetings',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/rfp-weddings',
                title: 'RFP Weddings',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/site-navigation',
                title: 'Header',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/statement-breaker',
                title: 'New Brand Statement Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/static-wrapper',
                title: 'Static Wrapper',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/staticsearchform',
                title: 'Booking Breaker',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/tabbed-hotel-map',
                title: 'Tabbed Hotel Map',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/components/ootb/title',
                title: 'Title',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/video-1-up',
                title: 'Video-1-Up',
              },
              {
                path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/header-responsivegrid/mi-aem-trc/proxy/components/content/wysiwyg-text',
                title: 'WYSIWYG',
              },
            ],
            applicable: false,
          },
          ':type': 'mi-aem-trc/components/content/container',
          ':itemsOrder': ['reference'],
          gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
          columnClassNames: { reference: 'aem-GridColumn aem-GridColumn--default--12' },
          columnCount: 12,
        },
      },
      allowedComponents: {
        components: [
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/1-up-collage',
            title: '1 Up Collage',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/2-up-recirculation',
            title: '2 Up Recirculation',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/3-up-card-breaker',
            title: '3 Up Card Breaker',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/3-up-recirculation',
            title: '3 Up Recirculation',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/article-hero-compact',
            title: 'Article Hero Compact',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/article-with-maps-references',
            title: 'Article Maps with References',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/basic-carousel',
            title: 'Basic Carousel',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/brand-footer',
            title: 'Brand Footer',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/brand-highlight-package',
            title: 'Brand Highlight Package',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/brand-statement-image',
            title: 'Brand Statement with Image',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/carousel-breaker',
            title: 'Carousel Breaker',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/contact-us',
            title: 'Contact Us',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/components/content/container',
            title: 'Container',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/editorial-highlight-3up',
            title: 'Editorial Highlight 3Up',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/editorial-highlight-package',
            title: 'Editorial Highlight Package',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/editorial-highlight-v1',
            title: 'Editorial Highlight V1',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/editorial-package-3up',
            title: 'Editorial Package 3 Up Basic',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/components/ootb/experiencefragment',
            title: 'Experience Fragment',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/featured-hotel-carousel',
            title: 'Featured Hotel Carousel',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/feed-module-with-filter',
            title: 'Feed Module With Filter',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/header-text-cta',
            title: 'Header with Text and CTA',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/homepage-hero',
            title: 'Homepage Hero',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/horizontal-accordion',
            title: 'Horizontal Accordion',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/horizontally-tabbed-list',
            title: 'Horizontally Tabbed List',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/hotel-carousel-with-bg',
            title: 'Featured Hotel Carousel w/ BG image',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/hotel-data-table',
            title: 'Hotel Data Table',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/hub-hero-basic',
            title: 'Hub Hero Basic',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/hub-hero-layered',
            title: 'Hub Hero Layered',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/image-breaker',
            title: 'Image and Collage Breaker',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/inline-card',
            title: 'Inline Card',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/inline-image',
            title: 'Inline Image',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/navigation',
            title: 'Navigation',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/quote-w-image',
            title: 'Quote With Image',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/recirculation-carousel',
            title: 'Recirculation Carousel',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/reference',
            title: 'Reference Component',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/reserve-accordion',
            title: 'Reserve Accordion',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/reserve-carousel-subnav',
            title: 'Reserve Carousel SubNavigation',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/reserve-contact-us',
            title: 'Reserve Contact Us',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/reserve-hero',
            title: 'Reserve Hero',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/reserve-hero-data-table',
            title: 'Reserve Hero Data Table',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/reserve-highlight-carousel',
            title: 'Reserve Highlight Carousel',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/reserve-site-nav',
            title: 'Reserve Site Nav',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/reserve-statement',
            title: 'Reserve Statement',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/rfp-meetings',
            title: 'RFP Meetings',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/rfp-weddings',
            title: 'RFP Weddings',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/site-navigation',
            title: 'Header',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/statement-breaker',
            title: 'New Brand Statement Breaker',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/static-wrapper',
            title: 'Static Wrapper',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/staticsearchform',
            title: 'Booking Breaker',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/tabbed-hotel-map',
            title: 'Tabbed Hotel Map',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/components/ootb/title',
            title: 'Title',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/video-1-up',
            title: 'Video-1-Up',
          },
          {
            path: '/content/marriott-trc/brand/na/en/weddings/jcr:content/root/mi-aem-trc/proxy/components/content/wysiwyg-text',
            title: 'WYSIWYG',
          },
        ],
        applicable: false,
      },
      ':type': 'mi-aem-trc/components/content/container',
      ':itemsOrder': ['header-responsivegrid', 'container', 'footer-responsivegrid'],
      gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
      columnClassNames: {
        container: 'aem-GridColumn aem-GridColumn--default--12',
        'footer-responsivegrid': 'aem-GridColumn aem-GridColumn--default--12',
        'header-responsivegrid': 'aem-GridColumn aem-GridColumn--default--12',
      },
      columnCount: 12,
    },
  },
  cssClassNames: 'dynamic-page page basicpage',
  ':type': 'mi-aem-trc/components/structure/dynamic-page',
  ':itemsOrder': ['root'],
  templateName: 'trc-dynamic-page-template',
  favIcon: '',
  ':path': '',
  id: 'dynamic-page-14e5027f37',
  staticComponentClientLibsJS: '/etc.clientlibs/mi-aem-trc/clientlibs/clientlib-site.min.js',
  metaProperties: [
    { name: 'ogTitle', value: '' },
    { name: 'ogDescription', value: '' },
    { name: 'imageURL', value: '' },
    { name: 'ogType', value: '' },
    { name: 'ogSiteName', value: '' },
    { name: 'fbAppId', value: '' },
    { name: 'ogUrl', value: '' },
  ],
  designPath: '/libs/settings/wcm/designs/default',
};
